import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ThomasCampaign, ThomasCampaignProduct, AdServer } from 'models/interfaces';
import { ApolloClient } from 'apollo-client';

export const OPTIMIZE_CAMPAIGN_MUTATION = gql`
  mutation SaveOptimizationCampaign($campaignId: String, $startDate: String, $name: String) {
    saveOptimizeCampaign(campaignId: $campaignId, startDate: $startDate, name: $name)
  }
`;

export const GET_CAMPAIGN_QUERY = gql`
  query GetCampaign($campaign_id: String!) {
    campaign: thomasCampaign(campaign_id: $campaign_id) {
      campaign_id
      name
      tgrams_id
      product_id
      start_date
      end_date
      status_id
      created_date
    }
    products: thomasCampaignProducts {
      product_id
      name
      abbreviation
      description
      created_date
    }
    adServers {
      ad_server_id
      name
      description
    }
  }
`;

const LIST_CAMPAIGNS_BY_VERTICAL_QUERY = gql`
  query ListThomasCampaignsByVertical($vertical_id: String!) {
    campaigns: thomasCampaignsByVertical(vertical_id: $vertical_id) {
      campaign_id
      tgrams_id
      product_id
      name
      start_date
      end_date
      created_date
    }
  }
`;

export const SAVE_CAMPAIGN_MUTATION = gql`
  mutation SaveCampaign($campaign: ThomasCampaignInput) {
    saveThomasCampaign(campaign: $campaign) {
      campaign_id
      tgrams_id
      product_id
      name
      start_date
      end_date
      status_id
    }
  }
`;

export const DUPLICATE_CAMPAIGN_MUTATION = gql`
  mutation DuplicateCampaign($campaign_id: String) {
    duplicateThomasCampaign(campaign_id: $campaign_id)
  }
`;

export const DELETE_CAMPAIGN_MUTATION = gql`
  mutation DeleteCampaign($campaign_id: String) {
    deleteThomasCampaign(campaign_id: $campaign_id)
  }
`;

interface ThomasCampaignContainerRenderProps {
  campaign: ThomasCampaign;
  campaigns: ThomasCampaign[];
  products: ThomasCampaignProduct[];
  adServers: AdServer[];
  client: ApolloClient<any>;
}

interface ThomasCampaignContainerProps {
  campaign_id?: string;
  vertical_id?: string | number;
  children: (props: ThomasCampaignContainerRenderProps) => any;
}

const ThomasCampaignContainer: React.FunctionComponent<ThomasCampaignContainerProps> = ({
  campaign_id,
  vertical_id,
  children,
  ...props
}) => {
  let query = GET_CAMPAIGN_QUERY;
  let vertical_id_new;
  if (vertical_id) {
    query = LIST_CAMPAIGNS_BY_VERTICAL_QUERY;
    vertical_id_new = typeof vertical_id === 'string' ? vertical_id : vertical_id.toString();
  }

  return (
    <Query<ThomasCampaignContainerRenderProps>
      query={query}
      variables={{ campaign_id, vertical_id: vertical_id_new }}
      fetchPolicy="network-only"
    >
      {({
        data: { campaign, products, adServers, campaigns } = {
          campaign: {} as ThomasCampaign,
          campaigns: [] as ThomasCampaign[],
          products: [] as ThomasCampaignProduct[],
          adServers: [] as AdServer[]
        },
        loading,
        client
      }) => {
        if (loading) {
          return null;
        }
        return (
          children &&
          children({
            ...props,
            campaigns,
            campaign: campaign,
            products: products,
            adServers,
            client
          })
        );
      }}
    </Query>
  );
};

export default ThomasCampaignContainer;
